import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {RouterModule, Routes} from '@angular/router';
// Material
import {MatAutocompleteModule} from '@angular/material/autocomplete';
import {MatButtonModule} from '@angular/material/button';
import {MatCardModule} from '@angular/material/card';
import {MatCheckboxModule} from '@angular/material/checkbox';
import {MatDatepickerModule} from '@angular/material/datepicker';
import {MatDialogModule} from '@angular/material/dialog';
import {MatIconModule} from '@angular/material/icon';
import {MatInputModule} from '@angular/material/input';
import {MatMenuModule} from '@angular/material/menu';
import {DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE, MatNativeDateModule, NativeDateModule} from '@angular/material/core';
import {MatPaginatorModule} from '@angular/material/paginator';
import {MatProgressBarModule} from '@angular/material/progress-bar';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import {MatRadioModule} from '@angular/material/radio';
import {MatSelectModule} from '@angular/material/select';
import {MatSnackBarModule} from '@angular/material/snack-bar';
import {MatSortModule} from '@angular/material/sort';
import {MatTableModule} from '@angular/material/table';
import {MatTabsModule} from '@angular/material/tabs';
import {MatTooltipModule} from '@angular/material/tooltip';
import {MAT_DIALOG_DEFAULT_OPTIONS} from '@angular/material/dialog';

import {HTTP_INTERCEPTORS, HttpClientModule} from '@angular/common/http';
import {EffectsModule} from '@ngrx/effects';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {StoreModule} from '@ngrx/store';
import {TranslateModule} from '@ngx-translate/core';
import {NgbModule, NgbPopoverModule, NgbProgressbarModule} from '@ng-bootstrap/ng-bootstrap';
import {NgxPermissionsModule} from 'ngx-permissions';
import {AssignmentEditComponent} from './assignments/assignment-edit/assignment-edit.component';
import {AssignmentResolver} from './assignments/assignment-edit/assignment-resolver';
import {PdfViewerModule} from 'ng2-pdf-viewer';
import {NgxMatSelectSearchModule} from 'ngx-mat-select-search';
import {MAT_MOMENT_DATE_ADAPTER_OPTIONS, MomentDateAdapter} from '@angular/material-moment-adapter';
import {SaveAssIdResolver} from './assignments/assignment-edit/save-ass-id-resolver';
import {CanDeactivateGuard, 
    // ModuleGuard
} from '../../../core/auth';
import {PartialsModule} from '../../partials/partials.module';
import {SharedModule} from '../shared_components/shared.module';
import {CustomPipesModule} from '../../theme/pipes/custom-pipes.module';

// core
import {AssignmentComponent} from './assignment.component';
import {AssignmentsListComponent} from './assignments/assignments-list/assignments-list.component';
import {
    AssignmentEffects, assignmentsReducer, AuditTrailEffects, AuditTrailParticipantEffects, auditTrailParticipantsReducer,
    AuditTrailReportEffects,
    AuditTrailReportService,
    auditTrailReportsReducer,
    auditTrailsReducer
} from '../../../core/assignment';
import {AssignmentsService, AuditTrailParticipantsService, AuditTrailsService} from '../../../core/assignment/_services';
import {HttpUtilsService, 
    // InterceptService, 
    LayoutUtilsService, TypesUtilsService} from '../../../core/_base/crud';
import {AuditListComponent} from './audit/audits-list/audit-list.component';
import {AuditEditComponent} from './audit/audit-edit/audit-edit.component';
import {AuditTrailGetResolver} from './audit/audit-edit/audit-trail-get-resolver';
import {AuditResolver} from './audit/audit-edit/audit-resolver';
import { UploadFileEffects } from 'src/app/core/file-upload';
import { ToeExcludeDialogComponent } from './audit/_sub/toe-exclude-dialog/toe-exclude-dialog.component';
import {DuplicateDialogComponent} from './assignments/_sub/duplicate-dialog/duplicate-dialog.component';
import {AssignmentDuplicateDialogComponent} from './assignments/_sub/assignment-duplicate-dialog/assignment-duplicate-dialog.component';
import {TpFilterPipe} from './assignments/_sub/tp-filter-pipe/tp-filter.pipe';
import { DeleteEntityWithDescrDialogComponent } from '../../partials/content/crud';
import { MadDateAdapter } from 'src/app/core/date/mad-date-adapter';
import { DuplicateAssignmentDialogComponent } from './components/duplicate-assignment-dialog/duplicate-assignment-dialog.component';
import { MadSharedModule } from '../mad_shared/shared.module';
import { FormFieldStateModule } from '../mad_shared/form-field-state/form-field-state.module';
import { FormTabHeaderModule } from '../mad_shared/form-tab-header/form-tab-header.module';

const routes: Routes = [
    {
        path: '',
        component: AssignmentComponent,
        children: [
            {
                path: '',
                redirectTo: 'assignments',
                pathMatch: 'full'
            },
            {
                path: 'assignments',
                component: AssignmentsListComponent
            },
            {
                path: 'assignments/add',
                component: AssignmentEditComponent,
                canDeactivate: [CanDeactivateGuard]
            },
            {
                path: 'assignments/edit/:id',
                component: AssignmentEditComponent,

                canDeactivate: [CanDeactivateGuard]
            },
            {
                path: 'assignments/:id/audit-trails',
                resolve: {data: AssignmentResolver},
                component: AuditListComponent
            },
            {
                path: 'assignments/:id/audit-trails/add',
                component: AuditEditComponent,
                canDeactivate: [CanDeactivateGuard]
            },
            {
                path: 'assignments/:id/audit-trails/edit/:audit_id',
                component: AuditEditComponent,
                resolve: {data: AuditTrailGetResolver}
            },
            {
                path: 'assignments/:id/audit-trails/show/:audit_id',
                component: AuditEditComponent,
                resolve: {data: AuditTrailGetResolver}
            },
            {
                path: 'assignments/:id/audit-trails/trash-detail/:audit_id',
                component: AuditEditComponent,
                resolve: {data: AuditResolver}
            },
            {
                path: 'assignments/:ass_id',
                // loadChildren: () =>
                //     import('../toe/toe.module').then(m => m.ToeModule),
                loadChildren: () => import('../toe/toe.module').then(m => m.ToeModule),
                resolve: {data: SaveAssIdResolver}
                // canActivate: [ModuleGuard],
            },
        ]
    }
];

@NgModule({
    imports: [
        MatDialogModule,
        NativeDateModule,
        CommonModule,
        HttpClientModule,
        PartialsModule,
        NgxPermissionsModule.forChild(),
        RouterModule.forChild(routes),
        FormsModule,
        ReactiveFormsModule,
        TranslateModule.forChild(),
        MatButtonModule,
        MatMenuModule,
        MatSelectModule,
        MatInputModule,
        MatTableModule,
        MatAutocompleteModule,
        MatRadioModule,
        MatIconModule,
        MatNativeDateModule,
        MatProgressBarModule,
        MatDatepickerModule,
        MatCardModule,
        MatPaginatorModule,
        MatSortModule,
        MatCheckboxModule,
        MatProgressSpinnerModule,
        MatSnackBarModule,
        MatTabsModule,
        MatTooltipModule,
        NgbProgressbarModule,
        PdfViewerModule,
        SharedModule,
        NgxMatSelectSearchModule,
        NgbModule,
        NgbPopoverModule,
        CustomPipesModule,
        StoreModule.forFeature('assignments', assignmentsReducer),
        EffectsModule.forFeature([AssignmentEffects]),
        StoreModule.forFeature('auditTrails', auditTrailsReducer),
        EffectsModule.forFeature([AuditTrailEffects]),
        StoreModule.forFeature('auditTrailParticipants', auditTrailParticipantsReducer),
        EffectsModule.forFeature([AuditTrailParticipantEffects]),
        StoreModule.forFeature('auditTrailReports', auditTrailReportsReducer),
        EffectsModule.forFeature([
            UploadFileEffects,
            AuditTrailReportEffects
        ]),
        MadSharedModule,
        FormFieldStateModule,
        FormTabHeaderModule
    ],
    providers: [
        // ModuleGuard,
        // InterceptService,
        // {
        //     provide: HTTP_INTERCEPTORS,
        //     useClass: InterceptService,
        //     multi: true
        // },
        // {
        //     provide: MAT_DIALOG_DEFAULT_OPTIONS,
        //     useValue: {
        //         hasBackdrop: true,
        //         panelClass: 'kt-mat-dialog-container__wrapper',
        //         maxHeight: 'auto',
        //         width: '900px'
        //     }
        // },
        {
            provide: DateAdapter,
            useClass: MadDateAdapter,
            deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS]
        },
        {
            provide: MAT_DATE_FORMATS, useValue: {
                parse: {
                    dateInput: 'DD MMM YYYY',
                },
                display: {
                    dateInput: 'DD MMM YYYY',
                    monthYearLabel: 'MMM YYYY',
                    dateA11yLabel: 'LL',
                    monthYearA11yLabel: 'MMMM YYYY',
                },
            }
        },
        TypesUtilsService,
        LayoutUtilsService,
        HttpUtilsService,
        AssignmentsService,
        AuditTrailsService,
        AuditTrailParticipantsService,
        AuditTrailReportService,
        TypesUtilsService,
        AssignmentResolver,
        AuditResolver,
        SaveAssIdResolver,
        AuditTrailGetResolver,
        CanDeactivateGuard
    ],
    declarations: [
        AssignmentComponent,
        // Assignments
        AssignmentsListComponent,
        AssignmentEditComponent,
        AuditListComponent,
        AuditEditComponent,
        AssignmentDuplicateDialogComponent,
        DuplicateDialogComponent,
        TpFilterPipe,
        ToeExcludeDialogComponent,
        DuplicateAssignmentDialogComponent
    ]
})
export class AssignmentModule {
}
